export { default } from './Slider.js';
